import React, { useMemo } from 'react';
import { styled } from 'styled-components';
import { Text } from '@ydistri/ds';
import { Popover } from 'antd';
import { RecordImportAction } from '@ydistri/api-sdk';

interface RedistributionImportValidatedItemActionProps {
  action: RecordImportAction;
  isSourceMissing: boolean;
  isTargetMissing: boolean;
  tooltip?: React.ReactNode;
}

const SuccessText = styled(Text).attrs({ $semiBold: true })`
  color: green;
`;
const ErrorText = styled(Text)`
  color: red;
`;
const UpdatedText = styled(Text).attrs({ $semiBold: true })`
  color: #f5940d;
`;

const RedistributionImportValidatedItemAction: React.FC<
  RedistributionImportValidatedItemActionProps
> = ({ action, isSourceMissing, isTargetMissing, tooltip }) => {
  const component = useMemo(() => {
    switch (action) {
      case RecordImportAction.Insert:
        return <SuccessText>Insert</SuccessText>;
      case RecordImportAction.CreateSkuAndInsert:
        if (isSourceMissing && isTargetMissing)
          return <SuccessText>Insert · create source and target SKUs</SuccessText>;
        if (isSourceMissing) return <SuccessText>Insert · create source SKU</SuccessText>;
        if (isTargetMissing) return <SuccessText>Insert · create target SKU</SuccessText>;
        return <SuccessText>Insert</SuccessText>;
      case RecordImportAction.Update:
        return <UpdatedText>{action}</UpdatedText>;
      case RecordImportAction.Delete:
      case RecordImportAction.NoChange:
        return <Text>{action}</Text>;
      case RecordImportAction.Skip:
      case RecordImportAction.Duplicate:
      case RecordImportAction.NotSet:
        return <ErrorText>{action}</ErrorText>;
      default:
        return <Text>Unknown</Text>;
    }
  }, [action, isSourceMissing, isTargetMissing]);

  if (tooltip) {
    return (
      <Popover content={tooltip} placement="topRight">
        {component}
      </Popover>
    );
  } else {
    return component;
  }
};

export default RedistributionImportValidatedItemAction;
